import { api } from './api';
import { FranchiseType } from './franchise';
import { PaginatedList, PaginatedRequest } from '../types';

export const getJurisdictions = (
  params: PaginatedRequest,
) =>
  api.request<JurisdictionList>({
    method: 'GET',
    url: '/jurisdictions/',
    params,
  });

export const getJurisdictionByID = (id: number) =>
  api.request<JurisdictionType>({
    method: 'GET',
    url: `/jurisdictions/${id}/`,
  });

export const createJurisdiction = (
  data: JurisdictionType,
) =>
  api.request<JurisdictionType>({
    method: 'POST',
    url: '/jurisdictions/',
    data,
  });

export const updateJurisdiction = (
  data: JurisdictionType,
) =>
  api.request<JurisdictionType>({
    method: 'PATCH',
    url: `/jurisdictions/${data.id}/`,
    data,
  });

export const deleteJurisdiction = (id: number) =>
  api.request<JurisdictionType>({
    method: 'DELETE',
    url: `/jurisdictions/${id}/`,
  });

type JurisdictionList = PaginatedList<JurisdictionType>;

export interface JurisdictionType {
  id: number;
  name: string;
  phoneNumber: string;
  building: string;
  email: string;
  isFranchiseAll: boolean;
  address: string;
  isDeleted: boolean;
  county: string;
  websitePropertyAppraiser: string;
  franchise: FranchiseType[] | number[];
}

export type JuriContactType = {
  contactName: string;
  phone: string;
  email: string;
  contactType: string;
  contactNotes: string;
  id: number;
};

export type JuriLinkType = {
  link: string;
  description: string;
  id:number;
}

export type PermittingFiles = 'perDiscipline' | 'individual' | 'none';
export type OnlineSub = 'full' | 'partial' | 'inPerson' | 'none'
export type WikiPermittingType = {
  files: PermittingFiles;
  id: number;
  isPackageSub: string;
  onlineSub: OnlineSub;
  password: string;
  permitEmail: string;
  portalLink: string;
  portalLinkDescription: string;
  username: string;
}

export type InspectionDataType = 'Request' | 'Result';

export type StepType = {
  id?: number;
  recordType: InspectionDataType;
  requestOrResult: string;
}

export type WikiInspectionType = {
  boContactPerson: string;
  boInspectionEmail: string;
  boInspectionPhone: string;
  id: number;
  inspectionCodesReport: string;
  inspectionCodesVisibleFilename: string;
  inspectionRequestSteps: string;
  inspectionResultSteps: string;
}

export type WikiJurisdictionType = {
  id: number;
  county: string;
  boName: string;
  boNumber: string;
  boEmail: string;
  jurisdictions: string;
  address: string;
  jurisdictionWebsite: string;
  website: string;
  street: string;
  city: string;
  state: string;
  zipCode: string;
  contacts: JuriContactType[];
  links: JuriLinkType[];
  permitting: WikiPermittingType;
  inspection: WikiInspectionType;
}

export type CountyObjectData = {
  id: number;
  name: string;
  state: string;
  websitePropertyAppraiser: string;
}

export type DropDownItemType = {
   title?: number,
   value: string,
   label?: string,
}
export type PermittingDocumentType = {
    work: DropDownItemType;
    building: DropDownItemType;
    permitType: DropDownItemType;
    documentType: DropDownItemType;
    fileName: string;
    documentName: string;
    permittingVisibleFilename?: string;
    wikiDocumentType?: number;
    isEditing?: boolean;
    id?: number;
}

export type WikiNoteType = {
  id?: number;
  topic: DropDownItemType;
  category: DropDownItemType;
  note: string;
  addedBy?: string;
  createdAt?: string;
  isEditing?: boolean;
}
export interface JurisdictionTableType {
  id: number;
  name: string;
  phoneNumber: string;
  building: string;
  email: string;
  address: string;
  isDeleted: boolean;
  isFranchiseAll: boolean;
  franchises: string;
  city: string;
  street: string;
  state: string;
  zipCode: string;
  county: CountyObjectData;
  franchise?: FranchiseType[] | number[];
  isDefault?: boolean;
  jurisdictionWebsite: string;
}

export type GlossaryImageType = {
  id: number;
  image: string;
  uploadedAt: string;
  uploadedBy: string;
};

export type GlossaryDataType = {
  createdAt: string;
  createdBy: number;
  definition: string;
  id: number;
  images: GlossaryImageType[];
  name: string;
  updatedAt: string;
  updatedBy: string;
};
